import { defineMessages, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { Hotkey } from 'ui-components/components/hotkey';
import { ModalService } from 'ui-components/services/modal-service';

export const messages = defineMessages({
  name: {
    description: 'modalHotkey.searchForOrder',
    defaultMessage: 'Search for Order',
    id: 'et2L5U',
  },
});

const defaultOnClose = () => {
  ModalService.closeLastOpenModal();
};

const BadScanOrderNumberSearch = ({ children, intl, onSearch = defaultOnClose }) => {
  const hotkeyMetadata = useMemo(
    () => ({
      displayHotkeyStrings: ['Enter'],
      doNotTrack: true,
      handler: onSearch,
      hotkey: ['Enter'],
      legacyCategory: 'general',
      name: intl.formatMessage(messages.name),
    }),
    [intl, onSearch],
  );

  return <Hotkey hotkey={hotkeyMetadata}>{children}</Hotkey>;
};

BadScanOrderNumberSearch.propTypes = {
  children: PropTypes.node.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onSearch: PropTypes.func,
};

export const SearchForOrderHotkey = injectIntl(BadScanOrderNumberSearch);
